var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.6667C26.6371 26.6667 29.2149 25.8847 31.4076 24.4196C33.6002 22.9545 35.3092 20.8721 36.3184 18.4358C37.3276 15.9994 37.5916 13.3185 37.0771 10.7321C36.5627 8.14572 35.2928 5.76994 33.4281 3.90524C31.5634 2.04054 29.1876 0.770668 26.6012 0.256198C24.0148 -0.258271 21.3339 0.00577327 18.8975 1.01494C16.4612 2.02411 14.3788 3.73308 12.9137 5.92573C11.4486 8.11839 10.6667 10.6963 10.6667 13.3333C10.6667 16.8696 12.0714 20.2609 14.5719 22.7614C17.0724 25.2619 20.4638 26.6667 24 26.6667ZM44 60C44.884 60 45.7319 59.6488 46.357 59.0237C46.9821 58.3986 47.3333 57.5507 47.3333 56.6667C47.3333 50.4783 44.875 44.5434 40.4991 40.1675C36.1233 35.7917 30.1884 33.3333 24 33.3333C17.8116 33.3333 11.8767 35.7917 7.50083 40.1675C3.12498 44.5434 0.666657 50.4783 0.666656 56.6667C0.666656 57.5507 1.01785 58.3986 1.64297 59.0237C2.26809 59.6488 3.11593 60 3.99999 60H44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7f8f96b73d7445de5906a5ca2e286b67.svg";
export { ForwardRef as ReactComponent };